import Api from '../../apis/meshApi';
import  ActionType  from '../../store/ActionType';
import { DatalinkAPIModels } from '../../generated/src/dlAPI';
import { showMeshOnMap, showMeshTiles, cleanUpMeshTiles } from '../map/MapFunctions';
import { IGlobalContext } from './AppWrapper';
import { MeshStatus } from '../../generated/src/models';
import OlView from 'ol/View';
import { IGetDataset } from '../../Models/IGetDataset';
interface DispatchExtractionBuilder {
  type: ActionType;
  data: DatalinkAPIModels.ExtractionBuilderData;
}

export const getExtractionBuilder = async ({
  meshName,
  projectID,
  modelType,
  globalDispatch,
}: {
  meshName: string;
  projectID: string;
  modelType: string;
  globalDispatch: (arg: DispatchExtractionBuilder) => void;
}) => {
  // console.log('getExtractionBuilder is being called');
  if (meshName !== '') {
    try {
      globalDispatch({
        type: ActionType.DATA_EXTRACTION_BUILDER_START, 
        data: true as any,
      });
      //TODO MASM: HERE SET THE SPINNER AT TRUE
      const response = await Api.getExtractionBuilder({
        projectGuid: projectID,
        meshName: meshName,
        modelType: modelType.replace(/\s+/g, ''),
      });
      globalDispatch({
        type: ActionType.SET_DATA_EXTRACTION_BUILDER,
        data: response.data,
      });
    } catch (e) {
      //TODO MASM: HERE SET THE SPINNER AT FALSE WITH ERROR
      console.log('error: ', e.message);
    }
  }
};

interface DispatchXyProviderCoords {
  type: ActionType;
  data: DatalinkAPIModels.XyProviderCoords;
  providerid: string;
}
export const getProviderXyCoords = async ({
  projectID,
  datasetGuid,
  meshName,
  modelType,
  globalDispatch,
}: {
  projectID: string;
  datasetGuid: string;
  meshName: string;
  modelType: string;
  globalDispatch: (arg: DispatchXyProviderCoords) => void;
}) => {
  try {
    const response = await Api.getProviderXyCoords({
      projectGuid: projectID,
      datasetGuid: datasetGuid,
      meshName: meshName,
      modelType: modelType.replace(/\s+/g, ''),
    });
    globalDispatch({
      type: ActionType.UPDATE_DATA_EXTRACTION_BUILDER,
      data: response.data,
      providerid: datasetGuid,
    });
    return response.data;
  } catch (e) {
    console.log('error: ', e.message);
  }
};

/* interface DispacthMeshBoundaries {
  type: ActionType;
  data: MeshBoundaries;
} */
export const getMeshBoundaries = async ({
  meshName,
  globalContext,
}: {
  meshName: string;
  globalContext: IGlobalContext;
}) => {
  const projectID = globalContext.state.project.currentProject.id;
  try {
    const response = await Api.getMeshBoundaries(projectID, meshName);
    // 0) save Mesh Boundaries json to store
    globalContext.dispatch({ type: ActionType.SET_MESH_NAME, data: meshName });
    // 1) show Mesh Boundaries on the Map

    //Clean MeshTiles so a new View can be reset and not conflict with a original MeshProjection
    cleanUpMeshTiles(globalContext.state);

    //Reset The Map View
    (globalContext.state.map as any).olMap.setView(
      new OlView({
        projection: 'EPSG:3857',
      })
    );
    showMeshOnMap(globalContext.state, globalContext.dispatch, response.data);
    // 2) TODO: automatically open mesh boundaries panel, and show the boundaries
  } catch (e) {
    console.log('error: ', e.message);
  }
};

export const getMeshBoundariesForLastMesh = ({
  meshFiles,
  globalContext,
}: {
  meshFiles: MeshStatus[];
  globalContext: IGlobalContext;
}) => {
  // Look for latest file wich hasBoundariesExtracted:
  for (let i = meshFiles.length - 1; i >= 0; i--) {
    if (meshFiles[i].hasBoundariesExtracted) {
      // console.log('response.data[i]: ', response.data[i]);
      getMeshBoundaries({
        meshName: meshFiles[i].meshName,
        globalContext,
      });
      break;
    }
  }
};

export const getListMeshStatus = async ({ globalContext }: { globalContext: IGlobalContext }) => {
  const projectID = globalContext.state.project.currentProject.id;
  // const projectID = globalState.project.currentProject.id;
  try {
    const response = await Api.listMeshStatus(projectID);
    // console.log('getListMeshStatus, list: ', response.data);
    globalContext.dispatch({
      type: ActionType.SET_MESH_FILES_IMPORTED,
      data: response.data as MeshStatus[],
    });
    return response;
  } catch (e) {
    console.log('error: ', e.message);
  }
};

export const getTileGridConfig = async ({
  meshName,
  projectID,
  globalContext,
}: {
  meshName: string;
  projectID: string;
  globalContext: IGlobalContext;
}) => {
  if (meshName !== '') {
    try {
      globalContext.dispatch({
        type: ActionType.SET_MESH_TILEGRID_PROCESS,
        data: true,
      });
      const response = await Api.getTileGridConfig(projectID, meshName, true);
      globalContext.dispatch({
        type: ActionType.SET_MESH_TILEGRID_CONFIG,
        data: JSON.parse(response.data),
      });
      showMeshTiles(globalContext.state, globalContext.dispatch, JSON.parse(response.data), true);
    } catch (e) {
      cleanUpMeshTiles(globalContext.state);
      console.log('error: ', e.message);
    }
  }
};


export const getProjectContent = async ({
  projectID,
  globalContext,
}: {
  projectID: string;
  globalContext: IGlobalContext;
}) => {
  try {
    globalContext.dispatch({
      type: ActionType.LOADING_PROJECTCONTENT,
      data: true,
    });
    const projectResponse = await Api.getProject(projectID);
    const datasetResponse = await Api.getProjectDatasets(projectID);
    const folderResponse = await Api.getSubProjects(projectID);
    const pathResponse = await Api.getProjectPath(projectID);
    const folders = folderResponse.data;
    const datasets = datasetResponse.data;

    const data = {
      project: projectResponse.data,
      path: pathResponse.data,
      projectContent: folders.concat(
        datasets.filter((dataset: IGetDataset) => dataset.datasetFormat.toLowerCase() === 'mesh')
      ),
    };
    globalContext.dispatch({
      type: ActionType.SET_PROJECTCONTENT,
      data: data,
    });
  } catch (e) {
    console.log('error: ', e.message);
  }
};

export const deleteMeshFiles = async ({
  projectID,
  meshFiles, 
}: {
  projectID: string;
  meshFiles: any[];
  globalContext: IGlobalContext;
}) => {
  try {
    const response = await Api.deleteMesh(projectID, meshFiles);
    console.log('response ', response);
  } catch (e) {
    console.log('error: ', e.message);
  }
};
